import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  itemsWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      gap: SPACES.xxl,
    },
  },
  item: {
    '&&': {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      padding: SPACES.xxl,

      backgroundColor: theme.palette.custom.white,
      border: `1px solid ${theme.palette.custom.grey}`,
      borderRadius: '10px',
    },
  },
  itemText: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.medium,
      fontSize: FONTS.SIZES.xl,
      lineHeight: 1.4,

      color: theme.palette.custom.darkBlue2,
    },
  },
}))

export { useStyles }
